import React, { useState, useContext } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { Container, Row, Col, Alert, Button } from "react-bootstrap"
import SwaggerContext from "../../SwaggerContext"
import { invitationService } from "../../services/invitationService"

const RejectInvitationPage = () => {
  const { token } = useParams()
  const navigate = useNavigate()
  const { isLoggedIn } = useSelector((state) => state.auth)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")
  const [message, setMessage] = useState("")
  const swaggerClient = useContext(SwaggerContext)

  const handleReject = async () => {
    setLoading(true)
    setError("")
    setMessage("")

    try {
      if (!isLoggedIn) {
        navigate(`/login?next=/invitation/reject/${token}`)
        return
      }

      if (!token) {
        throw new Error("Token inválido")
      }

      if (!swaggerClient?.invitationApi) {
        throw new Error("API no disponible")
      }

      const result = await invitationService.rejectInvitation(
        swaggerClient.invitationApi,
        token
      )

      if (result.success) {
        setMessage("Invitación rechazada correctamente")

        setTimeout(() => {
          navigate("/", {
            state: { message: "Invitación rechazada correctamente" },
          })
        }, 2000)
      } else {
        const errorMsg = result.error || "Error al rechazar la invitación"
        setError(errorMsg)
      }
    } catch (err) {
      const errorMsg = err instanceof Error ? err.message : "Error desconocido"
      setError(errorMsg)
    } finally {
      setLoading(false)
    }
  }

  if (!isLoggedIn) {
    return (
      <Container className="mt-5">
        <Row>
          <Col md={{ span: 8, offset: 2 }}>
            <h1 className="mb-4">Rechazar Invitación</h1>

            <Alert variant="info" className="mb-4">
              Necesitas estar logueado para rechazar una invitación.
            </Alert>

            <div className="d-grid gap-3">
              <Button
                variant="primary"
                size="lg"
                onClick={() => navigate(`/login?next=/invitation/reject/${token}`)}
              >
                Iniciar Sesión
              </Button>
              <Button
                variant="outline-primary"
                size="lg"
                onClick={() => navigate("/register")}
              >
                Crear Cuenta
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    )
  }

  return (
    <Container className="mt-5">
      <Row>
        <Col md={{ span: 8, offset: 2 }}>
          <h1 className="mb-4">Rechazar Invitación</h1>

          <div className="confirmation-box p-4 border rounded">
            <h2 className="mb-3">¿Deseas rechazar esta invitación?</h2>
            <p className="mb-3">Si rechazas esta invitación:</p>
            <ul className="mb-4">
              <li>No se te vinculará con el terapeuta</li>
              <li>No podrá ver tus estadísticas</li>
              <li>Podrás recibir otras invitaciones después</li>
            </ul>

            <div className="d-flex gap-2 mb-3">
              <Button
                variant="danger"
                size="lg"
                onClick={handleReject}
                disabled={loading}
                className="flex-grow-1"
              >
                {loading ? "Rechazando..." : "Confirmar Rechazo"}
              </Button>
              <Button
                variant="outline-secondary"
                size="lg"
                onClick={() => navigate("/")}
                disabled={loading}
                className="flex-grow-1"
              >
                Cancelar
              </Button>
            </div>

            {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
            {message && <Alert variant="success" className="mt-3">{message}</Alert>}
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default RejectInvitationPage
